import React, { createContext } from 'react'

import { IModalContext, ModalAction, ModalsContainerProps } from './ModalApi.types'

export const defaultModalContext: IModalContext = {
	show: () => {
		throw new Error('Missing modal api context provider')
	},
}

export const ModalContext = createContext<IModalContext>(defaultModalContext)

export const ModalsContainer = ({ modalActions }: ModalsContainerProps) => (
	<>
		{modalActions.map(({ element, props }: ModalAction, index) =>
			// eslint-disable-next-line react/no-array-index-key
			React.createElement(React.Fragment, { key: `${index}_${props.zIndex}` }, element),
		)}
	</>
)
